















































import { Component, Mixins, Prop } from "vue-property-decorator";
import CustomContainer from "@/components/Globals/CustomContainer.vue";
import CustomImage from "@/components/Globals/CustomImage.vue";
import CustomText from "@/components/Globals/CustomText.vue";
import CustomButton from "@/components/Globals/CustomButton.vue";
import SizeSelection from "@/components/molecule.ugcSizeSelection.content.vue";
import ugc from "@/mixins/UGC";
import imageLibrary from "@/mixins/imageLibrary";
import { external3DScene } from "@/mixins/external3DScene";
import undo from "@/mixins/Customizer/Undo";

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomImage,
    CustomText,
    SizeSelection,
  },
  mixins: [undo, ugc, imageLibrary],
})
export default class ImageGalleryContinueAndEditView extends Mixins(
  external3DScene
) {
  [x: string]: any;
  disabledCta: boolean = true;

  disableSizeSelect: boolean = false;

  get translations() {
    return this.$store.state.translations?.data?.modals?.addYourImageGallery;
  }

  get addYourImageGalleryChosseSizeTitle() {
    return  this.disableSizeSelector ? this.translations?.ugcEPStep3NoSize : this.translations?.addYourImageGalleryChosseSizeCopy;
  }

  get addYourImageGalleryDescription() {
    return this.disableSizeSelector ? this.translations?.ugcEPStep3DescriptionNoSize : this.translations?.addYourImageGalleryDescription;
  }

  get disableSizeSelector() : boolean {
    return this.$store.state.utils.configuration.ugc.disableSizeSelector;
  }

  get assetsPath() {
    const { endPoints } = this.$store.state;

    return (
      endPoints.customizer.customsAssets ||
      endPoints.ugcentrypoint.customsAssets
    );
  }

  get activeUGCComponentName() {
    return this.$store.state.ugc.tempData.features[
      this.$store.state.ugc.tempData.activeUGCIndex
    ].activeUGCComponent;
  }

  get isApparel() {
    return this.$store.getters["utils/isApparelEnabled"];
  }

  get ugcSize() {
    return this.$store.state.ugc.tempData.features[
      this.$store.state.ugc.tempData.activeUGCIndex
    ].ugc_size;
  }

  get selectedImages() {
    return this.$store.state.imageGallery.selectedImages;
  }

  disableAllCtas(isDisabled: boolean): void {
    this.disabledCta = isDisabled;
  }

  setSizeSelected() {
    const { tempData } = this.$store.state.ugc;
    const ugcSize = tempData.features[1].ugc_size;
    if (ugcSize) {
      this.$store.commit(
        "ugc/tempData/SET_TEMP_BUCKET_SIZE",
        this.$store.state.utils.bucketSizes[ugcSize]
      );
      this.$store.commit(
        "ugc/tempData/SET_BUCKET_SIZE",
        tempData.features[1].tempBucketSize
      );
    }
    this.$store.commit(
      "ugc/tempData/SET_UGC_SIZE",
      tempData.features[1].ugc_size
    );
    this.$store.commit(
      "buyPanel/REPLACE_SIZE_SELECTED",
      tempData.features[1].ugc_size
    );
  }

  continueToCustomizer() {
    (this as any).isPreviewDataLoading = false;
    this.$emit("isApplyingData", false);
    this.$emit("onCloseModal");
  }

  // TODO move to mixin and abstract reusable pieces
  async ctaPrimaryAction(): Promise<void> {
    this.isPreviewDataLoading = true;
    this.$emit("isApplyingData", true);
    this.$emit("showCloseIcon", false);
    this.disabledCta = true;

    const { tempData } = this.$store.state.ugc;
    const activeIndex = tempData.features[1];
    const { activeUGCComponent } = activeIndex;
    const storageRecipe = this.$store.getters["imageGallery/getStorageRecipe"];
    if (!storageRecipe) {
      // Set from recipe_v2 to avoid unfinished 2nd component flows from being added
      this.$store.commit("imageGallery/SET_LIBRARY_RECIPE", this.recipe_v2);
    }
    this.$eventBus.$emit("savePreviousSwatch", {
      feature: this.$recipe.getUGCFeatureType(activeUGCComponent),
    });
    const data = tempData.features[1].recipe.components[activeUGCComponent];
    this.setSizeSelected();
    await this.$store.dispatch("ugc/SAVE_ASSETS_3D");
    await this.reloadGallerySizes();
    await this.$store.dispatch(
      "ugc/SAVE_UGC_SWATCH",
      activeIndex.recipe.components[activeUGCComponent].ugc.ugc_swatch
    );

    const category = this.$store.state.imageGallery.image_category;
    const toolKitObject = {
      image_library_id: activeIndex.ugc_image_id,
      image_library_category: category,
    };
    data.toolkit_options = toolKitObject;
    this.$store.commit("ugc/tempData/UPDATE_COMPONENT", {
      componentName: activeUGCComponent,
      data,
    });
    this.$store.commit("recipe/UPDATE_COMPONENT", {
      componentName: activeUGCComponent,
      data,
    });
    this.$store.commit("imageGallery/UPDATE_LIBRARY_COMPONENT", {componentName: activeUGCComponent, data});
    this.$store.commit("imageGallery/SET_COMPONENT_CURRENT_IMAGE", {
      componentName: activeUGCComponent,
      category: category,
      ugcObject: data.ugc,
    });
    this.$ugcDataLayer.logAnalyticsEvent({
      action: 'imageLibrary',
      type: this.$ugcDataLayer.types.continueToCustomize
    });
    this.$eventBus.$emit("init-ugc-appliance", { personalizationData: null });

  }

  // MOVe these to mixin
  ctaSecondaryAction(): void {
    this.isPreviewDataLoading = true;
    this.$emit('isApplyingData', true);
    this.$emit('showCloseIcon', false);
    this.disabledCta = true;
    this.$ugcDataLayer.logAnalyticsEvent({
      action: 'imageLibrary',
      type: this.$ugcDataLayer.types.editAndPosition
    });
    const activeComponent =
      this.$store.state.legacyNavigation.activeComponent ||
      this.$store.state.standardNavigation.activeComponent;
    this.$store.commit("ugc/SET_CURRENT_FEATURE_UGC_VIEW", "ugc-design-view");
    this.$store.commit("ugc/tempData/SET_CONTINUE_EDIT_FLOW", true);
    // Remove component from ApplyUGCComponents for edit flow since it should be added until finishFlow in UgcModal TopBar
    this.$store.commit(
      "ugc/tempData/REMOVE_APPLY_UGC_COMPONENTS",
      activeComponent
    );
    this.load3DAssets();
  }

  load3DAssets() {
    this.$store.dispatch("ugc/SAVE_ASSETS_3D").then(() => {
      // Don't clear tempData needed for reposition flow
      this.goToNextStep();
      this.$store.commit("imageGallery/SET_IS_BACK_APPLIED", false);
      this.$modal.hide("addYourImageGallery");
      this.$modal.show(
        this.$store.state.utils.configuration.enableNewUgcModal
          ? "newUgcModal"
          : "ugcModal"
      );
      this.setSizeSelected();
      this.$emit("isApplyingData", false);
      this.isPreviewDataLoading = false;
    });
  }

  init3Dscene() {
    this.initExternal3Dscene({
      domEl: "confirm-3d-scene",
      sizeDivider: this.isApparel ? 1.6 : 1.8,
    });
  }

  setDefaultSize() {
    const ugcLoadingFromEntrypoint = this.$store.state.ugc.isUGCLoadingFromEntrypoint;
    const size = this.ugcSize
      ? this.ugcSize
      : this.$recipe.getUGCSizeFromRecipe();
    const ugcCustomizedComponents =
      this.$store.getters["ugc/getUGCCustomizedComponents"];
    const ugcComponents =
      this.$store.getters["ugc/getComponentsWithUGCApplied"];
    if (!!size) {
      this.$eventBus.$emit("set-preselected-size", size);
      // Disable size selection if user has finished a custom UGC or imgLib flow
      if (
        !ugcLoadingFromEntrypoint &&
        (ugcComponents.length ||
        (ugcCustomizedComponents.length &&
          !ugcCustomizedComponents.includes(this.activeUGCComponentName)))
      ) {
        this.disableSizeSelect = true;
        return;
      }
    }
    this.disableSizeSelect = false;
  }

  created() {
    this.$eventBus.$on("disable-finish-button", this.continueToCustomizer);
  }

  mounted() {
    (this as any).isPreviewDataLoading = true;
    this.$emit("isApplyingData", true);
    this.$nextTick(() => {
      this.init3Dscene();
      this.applyTexture({
        imgUrl:
          this.selectedImages[this.activeUGCComponentName].ugc_swatch
            ?.image_url,
        componentName: this.activeUGCComponentName,
      }).then(() => {
        this.setDefaultSize();
        this.animateExternal3dScene();
        this.$emit("isApplyingData", false);
        (this as any).isPreviewDataLoading = false;
        this.$nextTick(() => {
          document.querySelector<HTMLElement>('.continue-edit-buttons .primary')?.focus();
          document.querySelector<HTMLElement>('.new-modal-button-nav-container-cta')?.classList.add("hide");
        })
      });
      const { imageLibrary } = this.$store.state.utils.queryParams;
      if (imageLibrary && !this.$store.state.ugc.tempData.features[1].ugc_image) this.setComponentUgcImage();
      if(this.disableSizeSelector) {
        this.setSizeSelected();
        this.disabledCta = false;
      }
    });
  }

  beforeDestroy() {
    this.$eventBus.$off("disable-finish-button", this.continueToCustomizer);
  }

  destroyed() {
    this.disposeScene();
  }
}
